import plugin from 'ui/plugins/i18n';

export default plugin;
